module.exports = __webpack_public_path__ + "img/downhill_line4.f9a2c294.svg";